export default {
  client: {
    fetching: false,
    fetched: false,
    data: null
  }
}
